// dispositivo.ts — identificativo casuale di questo dispositivo, creato la prima volta e salvato sul telefono.
// Serve al server per i limiti (sfide al giorno), i blocchi tra persone e le sospensioni dopo le segnalazioni.
// È debole per natura (si perde cancellando i dati dell'app) e lo si dichiara come tale nell'informativa.
import { leggiPreferenza, salvaPreferenza } from "./preferenze.ts";
import { PREFERENZE } from "../costanti.ts";
import { DISPOSITIVO_REGEX } from "../../../condiviso/protocollo.ts";

const BYTE_DISPOSITIVO = 24; // 32 caratteri base64url

function casuale(): string {
  const b = new Uint8Array(BYTE_DISPOSITIVO);
  crypto.getRandomValues(b);
  return btoa(String.fromCharCode(...b)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

let inMemoria: string | null = null;

export function idDispositivo(): string {
  if (inMemoria) return inMemoria;
  const salvato = leggiPreferenza(PREFERENZE.dispositivo);
  if (salvato && DISPOSITIVO_REGEX.test(salvato)) {
    inMemoria = salvato;
    return salvato;
  }
  inMemoria = casuale();
  salvaPreferenza(PREFERENZE.dispositivo, inMemoria);
  return inMemoria;
}
